import React, { Component } from 'react';
import PropTypes from 'prop-types';
// import { Dropdown, Menu } from 'antd';
import styled from 'styled-components';
import { Popover, Menu, MenuItem, Position } from '@blueprintjs/core';

const ComponentWrapper = styled.div`
  margin-right: 16px;
  img {
    height: 30px;
    cursor: pointer;
  }
`;

const PopoverWraper = styled.div`
  background: white;
  border-radius: 4px;
  padding: 10px 5px;
  .title {
    font-size: 16px;
    font-weight: 600;
    margin-left: 15px;
    margin-bottom: 6px;
  }

  .bp3-popover-dismiss {
    align-items: center;
  }
`;

class AppList extends Component {
  render() {
    const { list } = this.props;
    const renderOverlay = () => (
      <PopoverWraper>
        <div className='title'>Ứng dụng</div>
        <Menu>
          {list.map((item, index) => (
            <MenuItem
              key={index}
              icon={item.icon}
              text={item.text}
              href={item.href}
              target='_blank'
            />
          ))}
        </Menu>
      </PopoverWraper>
    );

    return (
      <ComponentWrapper>
        <Popover content={renderOverlay()} position={Position.BOTTOM}>
          <img src={'/Mask-Group.svg'} alt='' />
        </Popover>
      </ComponentWrapper>
    );
  }
}

export default AppList;

AppList.propTypes = {
  list: PropTypes.array.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/app-list/index.js